import { useEffect } from 'react';

import useAuth from '@/hooks/useAuth';

import Tridion from '@/components/document/views/tridion/Tridion';

import Constants from '@/constants';

import { IframeView } from '../common';

import DocumentCompleteButton from '@/routes/Layout/Header/RightHeaderContent/DocumentCompleteButton';
import useTrainingHeartbeatPlanTimer from '@/routes/TrainingPlans/hooks/useTrainingHeartbeatTimer';

interface TrainingPlanProps {
  planId: string;
  refFileId?: string;
  refVersionId?: string;
  refUrl?: string;
  stepId: string;
  stepStatus: string;
  userIds?: string[];
  isTridion?: boolean;
  name?: string;
  lastModified?: string;
}

const TrainingPlan: React.FC<TrainingPlanProps> = ({
  planId,
  refFileId,
  refVersionId,
  refUrl,
  stepId,
  stepStatus,
  userIds,
  isTridion = false,
  name,
  lastModified,
}) => {
  const { data: auth } = useAuth();
  const userId = auth?.userId;

  const timerUserIds = userIds ?? (userId ? [userId] : []);

  const [startTimer, stopTimer] = useTrainingHeartbeatPlanTimer(
    planId,
    stepId,
    timerUserIds,
    stepStatus,
  );

  useEffect(() => {
    startTimer();
    return () => stopTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const url =
    refVersionId && refFileId
      ? `${Constants.PATHWAY_API_CONTENT_URL}/${refVersionId}/${refFileId}/index.html`
      : refUrl; // use reference url for Game resource, and Xyleme resource for new XP api

  return isTridion ? (
    <Tridion
      document={{ contentUrl: refUrl, name, lastModified, searchId: '' }}
      routedFrom="search"
      isTraining
    />
  ) : (
    <div className="flex-1 text-center">
      <div className="my-8 text-center">
        <DocumentCompleteButton />
      </div>
      <IframeView url={url} />
    </div>
  );
};

export default TrainingPlan;
